import { render, staticRenderFns } from "./plmCompliance.vue?vue&type=template&id=ca19e4bc&scoped=true"
import script from "./plmCompliance.vue?vue&type=script&lang=js"
export * from "./plmCompliance.vue?vue&type=script&lang=js"
import style0 from "./plmCompliance.vue?vue&type=style&index=0&id=ca19e4bc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ca19e4bc",
  null
  
)

export default component.exports